// extracted by mini-css-extract-plugin
export default {"containerCourses":"MainPage_containerCourses__7R0aI","coursesWrapper":"MainPage_coursesWrapper__j-dZT","mobileHidden":"MainPage_mobileHidden__IOsBY"};